import * as React from 'react';

const WarningCircleFilled24 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    d: "M12.006 18a1 1 0 1 0 0-2 1 1 0 1 0 0 2m.75-12h-1.5v8h1.5zm-.752 16C17.525 22 22 17.524 22 12.004s-4.475-9.995-9.996-9.995c-5.52 0-9.996 4.475-9.996 9.995S6.484 22 12.004 22",
    clipRule: "evenodd"
  }
));
WarningCircleFilled24.Size = 24;
WarningCircleFilled24.Title = "WarningCircleFilled";

export { WarningCircleFilled24 as default };
